module.exports = __webpack_public_path__ + "static/hero-8d8c2520dcabc1e24dbd058ed94f5414.jpg";